<template>
    <section class="sk-home__section sk-home__section--skeleton sk-home__sb-gifts--skeleton kts-pt-50 kts-pt-mb-50 kts-pb-25 kts-pb-mb-25">
        <div class="sk-home__container">
            <div class="sk-home__heading">
                <div class="sk-home__heading-title"></div>
                <div class="sk-home__heading-description"></div>
            </div>
            <div class="sk-home__content sk-home__content--sb-gifts kts-pt-25 kts-pt-mb-30">
                <div class="sb-gifts__items">
                    <div class="sb-gifts__item" v-for="item in resultProduct" :key="item">
                        <div class="sb-gifts__item-details"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    const resultProduct = ref(4);
</script>